export default __webpack_public_path__ + "assets/images/Arrow Down-fda79a10d113953b8eb2a7a9d8cb40ac.svg";